const EnergoCircleIcon = ({icon}) => {

    return (
        <div className="border border-2 rounded-circle energo-card-header-icon">
            {icon}
        </div>
    )
}
export default EnergoCircleIcon;